<template>
  <li>
    <a :href="link" target="_blank">
      <h4 class="hotelTourName">
        {{ hotelName }}
      </h4>
      <p class="hotelTourPrice">
        <span class="fontNo">{{ minPrice }}~{{ maxPrice }}</span
        >円
      </p>
      <p class="hotelTourText">
        {{ title }}
      </p>
      <p class="hotelTourText">{{ departure }}発 | {{ duration }}日間</p>
    </a>
  </li>
</template>

<script>
export default {
  name: 'TkPackbackTour',
  props: {
    hotelName: {
      type: String,
      required: true,
    },
    minPrice: {
      type: String,
      required: true,
    },
    maxPrice: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    departure: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
}
</script>
